import React from 'react'
import axios from 'axios'
import {
  Typography, Button, TextField, Select, MenuItem, IconButton, Chip, Grid
} from '@material-ui/core'
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons'

const STATUS_COLORS = { pending: '#9e9e9e', in_progress: '#1976d2', complete: '#2e7d32', na: '#bdbdbd' }
const STATUS_LABELS = { pending: 'Pending', in_progress: 'In Progress', complete: 'Complete', na: 'N/A' }

const cardStyle = {
  backgroundColor: '#fff', borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: 16, marginBottom: 16
}

const ChecklistCard = ({ title, items, sectionKey, projectId, url, onUpdate }) => {
  const [adding, setAdding] = React.useState(false)
  const [newLabel, setNewLabel] = React.useState('')
  const [newDueDate, setNewDueDate] = React.useState('')

  const handleAdd = () => {
    if (!newLabel.trim()) return
    axios.post(`${url}/api/bid-estimation/projects/${projectId}/post-close/${sectionKey}/items`, {
      label: newLabel.trim(), dueDate: newDueDate || null
    }).then(res => {
      onUpdate(res.data)
      setNewLabel('')
      setNewDueDate('')
      setAdding(false)
    }).catch(err => console.error('Add item failed:', err))
  }

  const handleStatusChange = (itemId, status) => {
    axios.put(`${url}/api/bid-estimation/projects/${projectId}/post-close/${sectionKey}/items/${itemId}`, { status })
      .then(res => onUpdate(res.data))
      .catch(err => console.error('Update failed:', err))
  }

  const handleDelete = (itemId) => {
    axios.delete(`${url}/api/bid-estimation/projects/${projectId}/post-close/${sectionKey}/items/${itemId}`)
      .then(res => onUpdate(res.data))
      .catch(err => console.error('Delete failed:', err))
  }

  const completeCount = (items || []).filter(i => i.status === 'complete' || i.status === 'na').length

  return (
    <div style={cardStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>{title}</Typography>
          <Chip size="small" label={`${completeCount}/${(items || []).length}`} style={{ fontSize: 10, height: 20 }} />
        </div>
        <Button size="small" startIcon={<AddIcon />} onClick={() => setAdding(true)}
          style={{ textTransform: 'none', fontSize: 11 }}>
          Add Item
        </Button>
      </div>

      {(items || []).map(item => (
        <div key={item._id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
          <Select
            value={item.status}
            onChange={e => handleStatusChange(item._id, e.target.value)}
            disableUnderline
            style={{ fontSize: 11, minWidth: 0 }}
            renderValue={val => (
              <span style={{ backgroundColor: STATUS_COLORS[val], color: '#fff', padding: '2px 6px', borderRadius: 8, fontSize: 10 }}>
                {STATUS_LABELS[val]}
              </span>
            )}
          >
            {Object.entries(STATUS_LABELS).map(([k, v]) => (
              <MenuItem key={k} value={k} style={{ fontSize: 12 }}>{v}</MenuItem>
            ))}
          </Select>
          <Typography variant="body2" style={{ flex: 1, fontSize: 13, textDecoration: item.status === 'complete' ? 'line-through' : 'none', color: item.status === 'na' ? '#999' : '#333' }}>
            {item.label}
          </Typography>
          {item.dueDate && (
            <Typography variant="caption" color="textSecondary" style={{ fontSize: 10 }}>
              {new Date(item.dueDate).toLocaleDateString()}
            </Typography>
          )}
          <IconButton size="small" onClick={() => handleDelete(item._id)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </div>
      ))}

      {adding && (
        <div style={{ marginTop: 8, display: 'flex', gap: 8, alignItems: 'center' }}>
          <TextField size="small" variant="outlined" placeholder="Item label..." value={newLabel}
            onChange={e => setNewLabel(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleAdd()}
            style={{ flex: 1 }} inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }} />
          <TextField size="small" variant="outlined" type="date" value={newDueDate}
            onChange={e => setNewDueDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            style={{ width: 140 }} inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }} />
          <Button size="small" onClick={handleAdd} variant="outlined" disabled={!newLabel.trim()}
            style={{ textTransform: 'none', fontSize: 11 }}>Save</Button>
          <Button size="small" onClick={() => setAdding(false)} style={{ textTransform: 'none', fontSize: 11 }}>Cancel</Button>
        </div>
      )}

      {(items || []).length === 0 && !adding && (
        <Typography variant="body2" color="textSecondary" style={{ fontSize: 12, padding: '8px 0' }}>
          No items yet.
        </Typography>
      )}
    </div>
  )
}

export default ChecklistCard
